<template>
    <div>

        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-input icon="fas fa-search" v-model="search" />
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <button type="button" class="btn btn-outline-success" @click="incluir ()">
                                Incluir
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum item identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Gestão de Estoque'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }} 
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <button type="button" class="btn btn-outline-primary btn-sm ml-3" @click="ver_parms(dado)"
                                data-toggle="tooltip" data-placement="top" title="Parâmetros de Estoque">
                                <i class="fas fa-tachometer-alt"></i>
                            </button>
                            <button type="button" class="btn btn-outline-secondary btn-sm ml-1" @click="importar(dado)"
                                data-toggle="tooltip" data-placement="top" title="Importar Parâmetros de Estoque">
                                <i class="fas fa-upload"></i>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <p class="alert alert-info">
            Deve ser incluído nesse cadastro cada estoque que será gerido do ponto de vista de saldos e ressuprimento. <br>
            Por exemplo, se uma unidade possui vários locais de armazenagem, mas a verificação de saldo para ressuprimento é verificada considerando o saldo de todos esses locais, deve ser criada uma gestão de estoque única para esses locais.<br>
            Os parâmetros de estoque (ponto de ressuprimento, estoque ideal, etc), são calculados para cada gestão de estoque (com seus locais de armazenagem vinculados) cadastrada.
        </p>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_estoque_grupo_local ? '' : 'Nova' }}
                            Gestão de Estoque
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_estoque_grupo_local" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    type="textarea"
                                    label="Observações"
                                    :validate="validate"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="number"
                                    label="Intervalo de Compra Padrão (dias)"
                                    placeholder="Apenas definido no item..."
                                    :validate="validate"
                                    v-model="item.in_intervalo_compra_padrao" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="number"
                                    label="Tempo Médio de Ressuprimento Padrão (dias)"
                                    placeholder="Apenas definido no item..."
                                    :validate="validate"
                                    v-model="item.in_tmr_padrao" />
                            </div>
                        </div>

                        <template v-if="item.locais && item.locais.length">
                            <small class="text-primary mt-3">Locais de Armazeagem</small>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(local, ilx) in item.locais" :key="ilx">
                                    {{ local.search }}
                                </li>
                            </ul>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="estoqueGrupoLocal" :id="item.id_estoque_grupo_local" v-if="item && item.id_estoque_grupo_local" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_grupo_local ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="parametrosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Parâmetros</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-danger" v-if="!item.locais || !item.locais.length">
                            Nenhum local de armazenagem vinculado.
                        </p>

                        Realizar o cálculo dos parâmetros de estoque.

                        <az-input 
                            type="checkbox-group"
                            label="CMM: Consumo Médio Mensal"
                            v-model="item.fl_cmm" />

                        <az-input 
                            type="checkbox-group"
                            label="ES: Estoque de Segurança"
                            v-model="item.fl_es" />

                        <az-input 
                            type="checkbox-group"
                            label="PR: Ponto de Ressuprimento"
                            v-model="item.fl_pr" />

                        <az-input 
                            type="checkbox-group"
                            label="EI: Estoque Ideal"
                            v-model="item.fl_ei" />

                        <div class="alert alert-danger mt-3">
                            <strong>Atenção!</strong> O cálculo dos parâmetros é uma ação irreversível e não pode ser desfeita.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="calcular_parms(item)">Calcular</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <importacao 
            ref="import" 
            service="estoque_grupo_locals" 
            :parms="{ id_estoque_grupo_local: ( item_import ? item_import.id_estoque_grupo_local : null ) }"
            :hide="true" 
            :titulo="( item_import ? item_import.search : null )"
            @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import Importacao from '../../cadastros/shared/Importacao.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: [],
            unidade: "", 
            item_import: null, 
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        Importacao, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => !this.unidade || item.id_unidade_operacao == this.unidade)
                .filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        importar (item) { 
            this.item_import = _.cloneDeep(item);
            this.$refs.import.iniciar_importacao();
        },

        calcular_parms (item) { 
            if ( !confirm('Confirma realizar o cálculo de parâmetros?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'estoque_item_parms', 
                func: 'calcular_parms_todos',
                dados: item, 
                toast: true, 
                modal: 'parametrosModal'
            });

        },

        ver_parms (item) { 
            this.validate = false;
            this.item = _.cloneDeep(item);
            this.item.fl_cmm = true;
            this.item.fl_es = true;
            this.item.fl_pr = true;
            this.item.fl_ei = true;

            $('#parametrosModal').modal('show');
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_estoque_grupo_local: null, 
                st_estoque_grupo_local: "",
                fl_ativo: true,
                in_intervalo_compra_padrao: null, 
                in_tmr_padrao: null, 
                locais: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service: 'estoque_grupo_locals',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'estoque_grupo_locals',
                dados: this.item, 
                modal: 'edicaoModal',
                reload: true, 
                callback: () => { 
                    this.$util.resync(this, 'estoque_grupo_locals.index');
                }
            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'estoque_grupo_locals', 
                dados: item, 
                callback: () => { 
                    this.$util.resync(this, 'estoque_grupo_locals.index');
                }
            });

        },
    },

    mounted () { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Gestão de Estoque", path: "/suprimentos/gestaoestoque" }
        ]);

        this.load ();
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>